import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router";
import { useContextHospi } from "../../context/ContextHospi";

interface WrapperProps {
  children: ReactNode;
}

export function GAnalyticsWrapper(props: WrapperProps) {
  const { currentUserRole, currentUserId, cognitoUser } = useContextHospi();
  const location = useLocation();

  useEffect(() => {
    window.dataLayer.push({
      event: "page_view",
      page: { page_type: location.pathname + location.search },
      user_id: currentUserId,
      user_type: currentUserRole,
      premium_user: cognitoUser?.account_type === "premium" ? true : undefined
    });
  }, [location.pathname]);

  return <>{props.children}</>;
}
